// =====================================================================================
// FILE: src/components/table/HeaderRow.jsx
// =====================================================================================
import React from "react";
import { THEME, FONTS } from "../../constants/theme";

// ✅ Helper to get column-specific tooltips
const getColumnTooltip = (col) => {
  // Asset columns that appear in multi-column tables (Game Timeline, In-Game)
  const multiColumnAssets = [
    "bigGfxVideos",        // Big Screen - GFX & Videos
    "cornerScreenGfxVideos", // Corner Screen - GFX & Videos
    "superScreenFull",     // Super Screen Full
    "superScreen169",      // Super Screen 16:9
    "superScreenSide",     // Super Screen Side
  ];
  
  // Asset columns that appear alone in single-column tables
  const singleColumnAssets = [
    "ledAllTypes",         // LED - All Types (LED Entitlements table)
    "iptvGfx",             // IPTV - GFX & Videos (IPTV table)
    "bigTvc",              // Big Screen - TVC (TVC table)
    "cornerTvc",           // Corner Screen - TVC (TVC table)
  ];
  
  if (multiColumnAssets.includes(col.key)) {
    return `${col.label}\n\nClick cells below to select content from the library.\nContent is optional – you can add to one column, both, or neither.`;
  }
  
  if (singleColumnAssets.includes(col.key)) {
    return `${col.label}\n\nClick cells below to select content from the library.\nContent is optional – not every row needs an asset linked.`;
  }
  
  return col.label;
};

export default function HeaderRow({ cols, stickyLeftMap, template }) {
  const headerCell = {
    fontSize: FONTS.sm,
    fontWeight: FONTS.medium,
    fontFamily: FONTS.family,
    padding: "12px 12px",
    borderRight: `1px solid rgba(255,255,255,0.1)`,
    background: THEME.dark,
    display: "flex",
    alignItems: "center",
    minHeight: 44,
    textTransform: "none",
    letterSpacing: "0.01em",
    color: THEME.textOnDark,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    boxSizing: "border-box",
  };

  const stickyStyle = (key) =>
    cols.find((c) => c.key === key)?.sticky
      ? {
          position: "sticky",
          left: stickyLeftMap[key],
          zIndex: 5,
          boxShadow: `1px 0 0 rgba(255,255,255,0.1)`,
        }
      : null;

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: template,
        border: "none",
        borderRadius: THEME.radiusMd,
        overflow: "hidden",
        position: "sticky",
        top: 0,
        zIndex: 4,
        background: THEME.dark,
        boxShadow: THEME.shadowLg,
        marginBottom: 8,
      }}
    >
      {cols.map((c, idx) => (
        <div
          key={c.key}
          style={{
            ...headerCell,
            ...(stickyStyle(c.key) || {}),
            borderRight: idx === cols.length - 1 ? "none" : headerCell.borderRight,
          }}
          title={getColumnTooltip(c)}
        >
          {c.label}
        </div>
      ))}
    </div>
  );
}
